export enum AllPermissions {
    Read = 'Read',
    Manage = 'Manage',
    Edit = 'Edit',
    Delete = 'Delete',
    Comment = 'Comment',
    Share = 'Share',
    Inactivate = 'Inactivate',
    Activate = 'Activate'
}

export type PermissionType =
    | AllPermissions.Read
    | AllPermissions.Manage
    | AllPermissions.Edit
    | AllPermissions.Delete
    | AllPermissions.Comment
    | AllPermissions.Share;

export type PermissionsType = {
    [key in AllPermissions]?: boolean;
};
